/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import AsadaCard from "./AsadaCard";

// reactstrap components
import { Col, Container, Row } from "reactstrap";

class AsadaHero extends React.Component {
  render() {
    return (
      <>
        <div className="position-relative">
          {/* Hero for FREE version */}
          <section className="section section-hero section-shaped">
            {/* Background circles */}
            <div className="shape shape-style-1 shape-default">
              <img src={require('../assets/img/theme/bg.jpg')} alt="..." className="d-block w-100"/>
              <span className="span-150" />
              <span className="span-50" />
              <span className="span-50" />
              <span className="span-75" />
              <span className="span-100" />
              <span className="span-75" />
              <span className="span-50" />
              <span className="span-100" />
              <span className="span-50" />
              <span className="span-100" />

            </div>
            <Container className="shape-container d-flex align-items-center py-lg">
              <div className="col px-0">
                <Row className="align-items-center justify-content-center">
                  <Col className="text-center" lg="6">
                    <img
                      alt="..."
                      className="img-fluid"
                      src={require('../assets/img/brand/asada-logo-white.png')}
                      style={{ width: "400px" }}
                    />
                    <p className="lead text-white">
                      Protegemos nuestro gran tesoro.
                    </p>

                    <Row xs="12">
                      <Col xs="12" md="6">
                        <AsadaCard
                          title="Misión"
                          body="Ofrecer los servicios de abastecimiento de agua potable a los habitantes de Puerto Viejo y La Virgen de Sarapiquí, para mejorar la calidad de vida"
                        />
                      </Col>
                      <Col xs="12" md="6">
                        <AsadaCard
                          title="Visión"
                          body="Una Asada sostenible, fortalecida integralmente, que se desarrolle y sea reconocida en el país, por la calidad con que brinda los servicios a los habitantes."
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
        </div>
      </>
    );
  }
}

export default AsadaHero;
